const verificationConstants = {
  VERIFICATION_GET_DATA_REQUEST: 'VERIFICATION_GET_DATA_REQUEST',
  VERIFICATION_GET_DATA_SUCCESS: 'VERIFICATION_GET_DATA_SUCCESS',
  VERIFICATION_GET_DATA_FAILURE: 'VERIFICATION_GET_DATA_FAILURE',
};

export default verificationConstants;